<template>
  <v-container class="fill-height justify-center">
    <div class="d-flex justify-center align-center">
      <v-card elevation="0">
        <v-card-text>
          <v-row class="justify-space-between align-center">
            <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" :to="'/coa'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="primary">mdi-file-cog</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    CoA
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/neraca'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="accent">mdi-scale-balance</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2"> Neraca </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/laba-rugi'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                    <v-icon size="100" color="pink">mdi-chart-bell-curve-cumulative</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Laba Rugi
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/jurnal'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="warning">mdi-file-document-edit-outline</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Jurnal
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/buku-besar'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                <!-- <v-card min-width="180" class="rounded-lg" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }"> -->
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="success">mdi-book-open-blank-variant</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Buku Besar
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <!-- <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="180" class="rounded-lg" :to="'/ake/music'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="100" color="#D400B8">mdi-cellphone</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    AKE
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
export default {
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
  },

  methods: {
    logout() {
      TokenService.removeToken();
      window.location = "/login";
    },
  },
};
</script>

<style>
</style>